module.exports = __webpack_public_path__ + "static/media/workshop.594c70a9.svg";